import { humanizeFieldKey } from "@/pages/Profiles/Audit/fieldLabels";

const TABLE_LABELS: Record<string, string> = {
  editorial_content_client: "Client",
  research_commentary: "Commentary",
  editorial_content_contact: "Contact",
  research_edition_bpa: "Edition practice area",
  research_edition_config_product: "Edition product",
  edition_config: "Edition settings",
  research_firm_ranking: "Firm ranking",
  editorial_content: "Firm/lawyer content",
  research_lawyer_ranking: "Lawyer ranking",
  editorial_content_matter: "Matter",
  research_bpa: "Practice area",
  research_practice_group: "Practice group",
  research_product: "Product",
  publication_config: "Publication settings",
  research_ranking_entity: "Ranking entity",
  research_ranking_table: "Ranking table",
  research_sars: "SARs scores",
  template_fields: "Template field",
};

const FIELD_LABELS: Record<string, string> = {
  post_content: "Editorial content",
  researcher_notes: "Researcher notes",
  editor_comment_box: "Editor comment box",
  clerks_commentary: "Clerks' commentary",
  review_status: "Review status",
  status: "Status",
  ranking_tier: "Tier",
  ranking_comment: "Ranking comment",
  ranking_trend: "Ranking trend",
  display_order: "Display order",
  display_name: "Display name",
  firm_name: "Firm name",
  office_name: "Office name",
  contact_name: "Lawyer name",
  submission_open_date: "Submission open date",
  submission_close_date: "Submission close date",
  publication_from_date: "Publication from date",
  publication_to_date: "Publication to date",
  lead_assignee_id: "Lead assignee",
  assigned_researcher_id: "Researcher",
  assigned_editor_id: "Editor",
  input_language: "Input language",
  output_language: "Output language",
  template_type: "Template type",
  is_tiered: "Tiered",
  is_lawyer_table: "Lawyer table",
  overall_submission: "Overall submission",
  created_by: "Created by",
  updated_by: "Updated by",
  created_at: "Created at",
  updated_at: "Updated at",
};

const ACTION_LABELS: Record<string, string> = {
  INSERT: "Created",
  UPDATE: "Updated",
  DELETE: "Deleted",
};

export const RESEARCH_TABLES = Object.entries(TABLE_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export function researchTableLabel(table: string): string {
  return TABLE_LABELS[table] ?? humanizeFieldKey(table);
}

export function researchFieldLabel(field: string): string {
  return FIELD_LABELS[field] ?? humanizeFieldKey(field);
}

export function researchActionLabel(action: string): string {
  return ACTION_LABELS[action] ?? action;
}
